<!-- Section -->
<section class="small-section bg-dark">
	<div class="relative container align-left">

		<div class="row">

			<div class="col-md-8 title-section">
				<h1 class="hs-line-11 font-alt mb-20 mb-xs-0">{{title}}</h1>
				<div class="hs-line-4 font-alt">{{subtitle}}</div>
			</div>

			<div class="col-md-4 mt-30 breadcrumb-container">
				<div *ngIf="breadcrumb" class="mod-breadcrumbs font-alt align-right">
					<a (click)="goHome()"><i class="fa fa-home"></i></a>&nbsp;/&nbsp;
					<ng-container *ngIf="subpage">
						<a (click)="goSub()">{{subpage}}</a>&nbsp;/&nbsp;
					</ng-container>
					<span>{{ breadcrumb }}</span>
				</div>
				<div class="loading-container">
					<app-loading *ngIf="loading" />
				</div>
			</div>

		</div>

	</div>
</section>
<!-- End Section -->